export default __webpack_public_path__ + "static/media/31.b816af67.png";